exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tight-checkbox-spacing .v-input__control{margin-bottom:-25px}.custom-border{border:1px solid #ccc;border-radius:1px;padding:8px;margin-top:8px;width:100%}", ""]);

// exports
